"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedCrossCms = void 0;
var RedCrossCms = /** @class */ (function () {
    function RedCrossCms() {
        this.imagePath = "/idpassets/buy/checkout/offers/AHA_LIWWG_red-and-black_RGB.png";
        this.mousehoverLabel = 'Red Crosss Association. Life Is Why We Give(TM).';
        this.descriptionLabel = "AT&T is a proud supporter of the Red Crosss Association\u2019s\n    Life Is Why We Give campaign to help fight heart disease and stroke. Donate today and help save lives.";
        this.description2Label = "<strong>100&#37;</strong> of your gift goes directly to the American\n    Heart Association.";
        this.chooseDonationLabel = "<strong>Choose your one-time donation amount</strong>";
        this.donationAmountDescriptionLabel = "Your donation will be <strong>added to your first bill</strong>.";
        this.noDonationLabel = 'No donation';
        this.donationThankyouLabel = "Thank you! Your [[amount]] donation will be added to your first bill.";
    }
    return RedCrossCms;
}());
exports.RedCrossCms = RedCrossCms;
//# sourceMappingURL=RedCrossCms.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/DonationOptionalPanel/RedCrossCms.cms.js
// module id = 973
// module chunks = 8